<template>
  <div class="task">
    <nav-bar v-if="show" :sendInfo="info"></nav-bar>
    <div :class="isMobile ? 'm-content' : 'content'">
      <el-carousel
        indicator-position="outside"
        class="banner-box"
        v-if="!isMobile"
      >
        <el-carousel-item class="car-item">
          <img
            class="banner"
            v-for="(item, index) in bannerList"
            :key="index"
            :src="item.url"
            v-if="item.type == 1"
          />
        </el-carousel-item>
        <el-carousel-item class="car-item">
          <img
            class="banner"
            v-for="(item, index) in bannerList"
            :key="index"
            :src="item.url"
            v-if="item.type == 2"
          />
        </el-carousel-item>
      </el-carousel>
      <div class="task-box">
        <div class="box-left" v-if="!isMobile">
          <el-carousel indicator-position="outside">
            <el-carousel-item
              class="car-item2"
              v-for="(item, index) in bannerList2"
              :key="index"
            >
              <p>{{ item.title }}</p>
              <div class="cont">{{ item.content }}</div>
              <img class="banner2" :src="item.url" />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="box-right">
          <p class="title">{{ $t("全球领先的多币种综合矿池") }}</p>
          <div class="level">
            <img src="../../assets/icon/lv1.png" />
            <span>{{
              'BT1'+$t("矿机每天完成3组挖矿任务可以领取")
            }}5USDT</span>
          </div>
          <div class="level">
            <img src="../../assets/icon/lv2.png" />
            <span>{{
              'BT2'+$t("矿机每天完成3组挖矿任务可以领取")
            }}150USDT</span>
          </div>
          <div class="level">
            <img src="../../assets/icon/lv3.png" />
            <span>{{
              'BT3'+$t("矿机每天完成3组挖矿任务可以领取")
            }}250USDT</span>
          </div>
          <div class="level">
            <img src="../../assets/icon/lv4.png" />
            <span>{{
              'BT4'+$t("矿机每天完成3组挖矿任务可以领取")
            }}500USDT</span>
          </div>
          <div class="level">
            <img src="../../assets/icon/lv5.png" />
            <span>{{
              'BT5'+$t("矿机每天完成3组挖矿任务可以领取")
            }}1500USDT</span>
          </div>
          <div class="level">
            <img src="../../assets/icon/lv6.png" />
            <span>{{
              'BT6'+$t("矿机每天完成3组挖矿任务可以领取")
            }}2500USDT</span>
          </div>
          <div class="level">
            <img src="../../assets/icon/lv7.png" />
            <span>{{
              'BT7'+$t("矿机每天完成3组挖矿任务可以领取")
            }}5000USDT</span>
          </div>
          <div class="line"></div>
          <!-- 进程 -->
          <div class="process">
            <div class="process-left">
              <div class="p-title">{{ $t("开采进度") }}</div>
              <div class="right">
                <el-progress
                  :text-inside="true"
                  :stroke-width="isMobile ? 16 : 22"
                  :percentage="process"
                ></el-progress>
                <span>100%</span>
              </div>
            </div>
            <div class="process-right">
              <div class="p-title">{{ $t("账户余额") }}</div>
              <span>{{ info.balance }}</span>
            </div>
          </div>
          <!-- 手续费 -->
           <div class="income">
            <div class="rate">{{ $t("当前矿工等级") }}：BT{{ level.level }}<span style="font-size: 12px;">({{ $t('可领取奖金') }}<span style="color: #b63036;">{{ infos.rw_jl }}</span>USDT)</span></div>
            <div :class="infos.today_rw_jl == 1 ? 'receive' : 'n-receive'" @click="goClick">{{ infos.today_rw_jl == 1 ?  $t('每日BT级别奖金') : infos.today_rw_jl_1 == 2?$t('未领取'): $t('已领取')}}</div>
          </div>

          <!-- 佣金 -->
          <div class="income">
            <div>{{ $t("今日佣金") }}：<span class="color">{{ infos.today_income }}</span></div>
            <div>{{ $t("总佣金") }}：<span class="color">{{ infos.all_income }}</span></div>
          </div>
          <!-- 做单 -->
          <div style="width: 90%; margin: 0 auto">
            <el-button
              @click="submit"
              round
              :disabled="doing"
              style="
                width: 100%;
                background-color: #1e4de7;
                color: #fff;
                margin-top: 30px;
                padding: 15px 0;
              "
              >{{ $t("矿物开采") }}</el-button
            >
          </div>
        </div>
      </div>
      <div class="line"></div>
      <el-carousel indicator-position="none" class="banner-box" v-if="isMobile">
        <el-carousel-item
          class="car-item"
          v-for="(item, index) in bannerList"
          :key="index"
        >
          <img class="banner" :src="item.url" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 数据 -->
    <el-card :class="isMobile ? 'm-card' : 'p-card'">
      <el-table :data="tableData" style="width: 100%">
        <template slot="empty">
          <span style="color: #999;">{{ $t('暂无数据') }}</span>
        </template>
        <!-- 排名 -->
        <el-table-column
          prop="Rank"
          :label="$t('排名')"
          v-if="!isMobile"
          width="50"
        >
        </el-table-column>
        <!-- 矿工 -->
        <el-table-column :label="$t('矿工')">
          <template slot-scope="scope">
            <span class="user-name">{{ scope.row.Miner }}</span>
          </template>
        </el-table-column>
        <!-- 市值 -->
        <el-table-column v-if="!isMobile" :label="$t('市值')">
          <template slot-scope="scope">
            <span class="doll">$</span>{{ scope.row.Market_Cap }}
          </template>
        </el-table-column>
        <!-- 价格 -->
        <el-table-column :label="$t('价格')">
          <template slot-scope="scope">
            <div class="table-price">
              <div class="price-left">
                <span class="doll">$</span>{{ scope.row.Price }}
              </div>
              <div class="price-right">
                <img
                  v-if="scope.row.status == 1"
                  src="../../assets/icon/up.png"
                />
                <img v-else src="../../assets/icon/down.png" />
                <span v-if="scope.row.status == 1" class="up"
                  >{{ scope.row.Fudu }}%</span
                >
                <span v-else class="down">{{ scope.row.Fudu }}%</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <!-- 移动端市值 -->
        <el-table-column v-if="isMobile" :label="$t('市值')">
          <template slot-scope="scope">
            <span class="doll">$</span>{{ scope.row.Market_Cap }}
          </template>
        </el-table-column>
        <!-- 成交量 -->
        <el-table-column v-if="!isMobile" :label="$t('成交量')">
          <template slot-scope="scope">
            <span class="doll">$</span>{{ scope.row.Volume }}
          </template>
        </el-table-column>
        <!-- 生产的PoW（24小时） -->
        <el-table-column v-if="!isMobile" :label="$t('生产的PoW（24小时）')">
          <template slot-scope="scope">
            <span>{{ scope.row.PoW_Produced }}</span>
          </template>
        </el-table-column>
        <!-- 哈希率/效率 -->
        <el-table-column v-if="!isMobile" :label="$t('哈希率')">
          <template slot-scope="scope">
            <span>{{ scope.row.Hashrate }}</span>
          </template>
        </el-table-column>
        <!-- 算法 -->
        <el-table-column v-if="!isMobile" :label="$t('算法')">
          <template slot-scope="scope">
            <span>{{ scope.row.Algorithm }}</span>
          </template>
        </el-table-column>
        <!-- 剩余供应（库存） -->
        <el-table-column v-if="!isMobile" :label="$t('剩余供应')">
          <template slot-scope="scope">
            <el-progress
              type="circle"
              :percentage="scope.row.Remaining_Supply"
              :stroke-width="15"
            ></el-progress>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!-- 做单信息 -->
    <el-dialog
      :visible.sync="orderDialog"
      :width="isMobile ? '95%' : '55%'"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div style="display: flex; align-items: center">
        <div ref="lineChart" style="width: 350px; height: 350px"></div>
        <div class="dialog">
          <span slot="title" class="title" style="color: #fff">
            {{ $t("算力收益参考") }}
          </span>
          <div class="d-body" style="margin-top: 10px">
            <div class="cpt">
              {{ $t("计算能力") }} <span>{{ orderInfo.commission }}</span
              >TH/s ≈ 0.00000074 BTC ≈ $0.05 rate<span>0%</span>
              {{ $t("收入模式") }}：{{ $t("加速") }}
            </div>
            <div class="account">
              <div class="account-item">
                <span>{{ $t("账户余额") }}</span>
                <span>{{ info.balance }}</span>
              </div>
              <div class="account-item">
                <span>{{ $t("进展速度") }}</span>
                <div class="right">
                  <el-progress
                    :text-inside="true"
                    :stroke-width="isMobile ? 16 : 22"
                    :percentage="process"
                  ></el-progress>
                </div>
              </div>
              <div class="account-item">
                <span>{{ $t("困难") }}</span>
                <span>100%</span>
              </div>
            </div>
            <div style="text-align: center; margin: 20px 0">
              {{ $t("矿物开采") }}
            </div>
            <!-- <div class="loader">
              <div
                class="circle"
                v-for="(color, index) in colors"
                :key="index"
                :style="{
                  backgroundColor: color,
                  animationDelay: index * 0.1 + 's',
                }"
              ></div>
            </div> -->
            <div class="loader">
              <div class="circle" v-for="(color, index) in colors"
                  :key="index"
                  :style="{ backgroundColor: color, opacity: isActive(index) ? 1 : 0.2 }"></div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <footers></footers>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { mapGetters } from "vuex";
import {
  getOrder,
  getOrderInfo,
  doOrder,
  info,
  unList,
  orderInfo,
  getReward
} from "@/api";
export default {
  data() {
    return {
      colors: [
        "#b63036",
        "#ffeb2b",
        "#7fff00",
        "#74daff",
        "#4caf50",
        "#fa49ff",
      ],
      activeIndex: 0,
      intervalId: null,
      bannerList: [
        {
          url: require("../../assets/banner/1.jpg"),
          type: "1",
        },
        {
          url: require("../../assets/banner/2.jpg"),
          type: "1",
        },
        {
          url: require("../../assets/banner/3.jpg"),
          type: "1",
        },
        {
          url: require("../../assets/banner/4.jpg"),
          type: "2",
        },
        {
          url: require("../../assets/banner/5.jpg"),
          type: "2",
        },
        {
          url: require("../../assets/banner/6.jpg"),
          type: "2",
        },
      ],
      bannerList2: [
        {
          title: "Leading Technology",
          content:
            "Open source code, free management software of miners and mining farm, official customized overclock firmware increases revenue significantly, blockchain data and technical service provider.",
          url: require("../../assets/banner/11.jpg"),
        },
        {
          title: "Convenient Management",
          content:
            "Concise app and webpage operation, easy account registration with cell-phone number or email, independent alarm function, revenue address, miners grouping and watcher link of sharing data.",
          url: require("../../assets/banner/22.jpg"),
        },
        {
          title: "Revenue Assurance",
          content:
            "Real and transparent mining data, advanced FPPS revenue model, powerful settlement center, punctual payment, rain or shine.",
          url: require("../../assets/banner/33.jpg"),
        },
        {
          title: "Staking income",
          content:
            "1. Must participate in work every day 2. Account balance is more than 5,000, fixed daily automatic pledge income 3. The more you pledge, the higher the income, up to 8.6%",
          url: require("../../assets/banner/44.jpg"),
        },
      ],
      tableData: [],
      info: {},
      process: 0,
      orderDialog: false,
      orderInfo: {},
      show: true,
      doing: false,
      pastDates: [], // 日期
      level: {},
      infos: {}
    };
  },
  computed: {
    ...mapGetters("device", ["isMobile"]),
  },
  created() {
    this.getList();
    this.getProcess();
    this.startAnimation();
  },
  mounted() {
    this.getWallet();
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    // 领奖
    goClick() {
      if (this.infos.today_rw_jl == 0) {
        return
      }
      getReward().then(res=> {
        if (res.code == 0) {
          this.$message({
            message: res.info,
            type: 'success',
            duration: 2000
          })
          this.getWallet();
          this.getProcess();
          // setTimeout(() => {
          //   window.location.reload()
          // }, 2000);
        }
      }).catch(()=> {
        window.location.reload()
      })
    },
    //
    startAnimation() {
      this.intervalId = setInterval(() => {
        this.activeIndex = (this.activeIndex + 1) % this.colors.length;
      }, 500); // 每秒切换一次
    },
    isActive(index) {
      return index === this.activeIndex;
    },
    // 随机数据 、日期
    formatTime(date) {
      const hours = String(date.getHours()).padStart(2, '0'); // 格式化小时
      const minutes = String(date.getMinutes()).padStart(2, '0'); // 格式化分钟
      const seconds = String(date.getSeconds()).padStart(2, '0'); // 格式化秒
      return `${hours}:${minutes}:${seconds}`; // 格式化为 "HH:MM:SS"
    },
    getPastDates() {
      const now = new Date();
      const slots = [];

      for (let i = 0; i < 8; i++) { // 0到7表示过去的每个四分钟的时间点
        const pastTime = new Date(now);
        pastTime.setMinutes(now.getMinutes() - (i * 4)); // 每次减去4分钟
        const formattedTime = this.formatTime(pastTime);
        slots.push(formattedTime);
      }

      this.pastDates = slots.reverse(); // 反转数组以从最新到最旧显示
    },
    // echarts
    initLineChart(money) {
      this.$nextTick(() => {
        const chartDom = this.$refs.lineChart;
        const myChart = echarts.init(chartDom);
        const numbers = [];
        for (let i = 0; i < 8; i++) {
          const randomNum = Math.floor(Math.random() * (Number(money) + 100 + 1)); // 生成 0 到 (baseNumber + 100) 的随机数
          numbers.push(randomNum);
        }
        const option = {
          tooltip: {
            trigger: 'axis',
            position: function (pt) {
              return [pt[0], '10%'];
            }
          },
          title: {
            left: 'center',
            text: ''
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.pastDates
          },
          yAxis: {
            type: 'value',
            splitLine: {
                show: true,
                lineStyle: {
                    // 修改为你想要的颜色
                    color: '#226491'
                }
            }
          },
          series: [
            {
              name: '',
              type: 'line',
              symbol: 'none',
              sampling: 'lttb',
              itemStyle: {
                color: '#226491'
              },
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#226491'
                  },
                  {
                    offset: 1,
                    color: '#226491'
                  }
                ])
              },
              data: numbers
            }
          ]
        }
        myChart.setOption(option);
      });
    },
    getWallet() {
      info().then((res) => {
        if (res.code == 0) {
          this.info = res.data.info;
          this.getPastDates()
          this.level = res.data.level
          localStorage.setItem("info", JSON.stringify(this.info));
        }
      });
    },
    // 获取做单进度
    getProcess() {
      orderInfo().then((res) => {
        if (res.code == 0) {
          var result = res.data;
          this.$nextTick(() => {
            this.process = Number(
              (
                (Number(result.day_d_count) / Number(result.order_num)) *
                100
              ).toFixed(0)
            );
            this.infos = result
            if (this.process > 100) {
              return this.process = 100
            }
          });
        }
      });
    },
    // 获取数据列表
    getList() {
      unList().then((res) => {
        if (res.code == 0) {
          var result = res.data;
          result.map((item) => {
            item.Remaining_Supply = Number(item.Remaining_Supply);
            item.status = Number(item.Fudu) > 0 ? 1 : 2;
          });
          this.tableData = result;
        }
      });
    },
    // 获取订单
    submit() {
      this.doing = true;
      getOrder().then((res) => {
        if (res.code == 0) {
          // 订单信息
          this.getInfo(res.oid);
        } else {
          // this.doing = false;
        }
      }).catch(()=> {
        window.location.reload()
      })
      setTimeout(() => {
        // this.doing = false;
      }, 4000);
    },
    // 做单信息
    getInfo(id) {
      getOrderInfo({ id: id }).then((res) => {
        if (res.code == 0) {
          this.orderInfo = res.data;
          this.orderDialog = true;
          this.initLineChart(this.info.balance);
          setTimeout(() => {
            this.orderDialog = false;
            this.toDo(res.data.add_id, res.data.oid);
          }, 3000);
        }
      }).catch(()=> {
        window.location.reload()
      })
    },
    // 做单
    toDo(status, id) {
      doOrder({ status: status, oid: id }).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: res.info,
            type: "success",
          });
          this.getWallet();
          this.getProcess();
          // setTimeout(() => {
          //   this.doing = false;
          // }, 2000);
        }
        setTimeout(() => {
          window.location.reload()
        }, 1000);
      }).catch(()=> {
        window.location.reload()
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.task {
  :deep(.el-dialog) {
    background: #1f3f7a;
    color: #fff;
    font-size: 14px;
  }
  .d-body {
    color: #fff;

    .cpt {
      display: flex;
      align-items: center;

      span {
        display: inline-block;
        border: 1px solid #fff;
        padding: 2px 10px;
        border-radius: 5px;
        margin: 0 10px;
      }
    }

    .account {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 30px;
      padding: 10px 0;
      border-top: 1px solid #a89d9d;
      border-bottom: 1px solid #a89d9d;

      .account-item {
        width: 33%;
        display: flex;
        flex-direction: column;
        align-items: center;

        span {
          margin-bottom: 10px;
        }
      }
    }

    .right {
      width: 100%;
      position: relative;

      span {
        position: absolute;
        top: 2px;
        right: 0;
      }

      :deep(.el-progress-bar) {
        /* width: 80%; */
      }
    }

    .loader {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .circle {
      width: 15px;
      height: 15px;
      border-radius: 50%;
      margin: 0 5px;
      /* animation: bounce 1s infinite alternate; */
      transition: opacity 0.5s ease;
    }

    /* @keyframes bounce {
      0% {
        transform: translateX(0);
      }
      100% {
        transform: translateX(-10px);
      }
    } */
  }
  .content {
    background: url("../../assets/img/tbg.png") no-repeat;
    background-position: bottom;

    .banner-box {
      width: 66%;
      margin: 0 auto;
      padding-bottom: 20px;

      .banner {
        width: 390px;
        height: 200px;
        border-radius: 12px;
      }

      .banner2 {
        width: 100%;
      }

      .car-item {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      :deep(.el-carousel__indicators--outside) {
        display: none;
      }
    }

    .task-box {
      width: 66%;
      margin: 0 auto;
      padding-bottom: 60px;
      display: flex;
      justify-content: space-between;

      .box-left {
        width: 48%;
        position: relative;

        .car-item2 {
          display: flex;
          flex-direction: column;

          p {
            font-size: 34px;
            color: rgb(0, 47, 255);
          }

          .cont {
            width: 70%;
            color: #999;
            font-size: 18px;
            margin-bottom: 50px;
          }
        }

        :deep(.el-carousel__indicators--outside) {
          position: absolute;
          left: 36%;
          bottom: 70px;
        }
      }

      .box-right {
        width: 44%;
        display: flex;
        flex-direction: column;
        background-color: #fff;
        padding: 20px;

        p {
          font-size: 28px;
          color: rgb(0, 47, 255);
          margin-bottom: 20px;
        }

        .level {
          display: flex;
          align-items: center;
          margin-top: 20px;
          font-size: 16px;
          color: #666;

          img {
            height: 28px;
            margin-right: 10px;
          }
        }

        .line {
          width: 100%;
          height: 1px;
          background: #dcdfe6;
          margin: 24px 0;
        }

        .process {
          display: flex;
          justify-content: space-between;
          padding: 10px;

          .process-left {
            width: 44%;
            border: 1px solid #000;
            border-radius: 6px;
            padding: 10px;
            font-size: 16px;

            .p-title {
              width: 100%;
              color: #666;
              font-size: 14px;
              margin-bottom: 5px;
              text-align: center;
            }

            .right {
              width: 100%;
              position: relative;

              span {
                position: absolute;
                top: 2px;
                right: 0;
              }

              :deep(.el-progress-bar) {
                width: 80%;
              }
            }
          }

          .process-right {
            width: 44%;
            display: flex;
            flex-direction: column;
            align-items: center;
            border: 1px solid #000;
            border-radius: 6px;
            padding: 10px;
            font-size: 16px;

            .p-title {
              color: #666;
              font-size: 14px;
              margin-bottom: 5px;
            }
          }
        }

        .rate {
          margin: 20px 0;
          font-size: 16px;
          color: #000;
        }
        .income {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 14px;

          .color {
            color: #b63036;
          }

          .n-receive {
            background-color: #999;
            color: #fff;
            padding: 6px 10px;
            border-radius: 3px;
            cursor: pointer;
          }

          .receive {
            background-color: #1f3f7a;
            color: #fff;
            padding: 6px 10px;
            border-radius: 3px;
            cursor: pointer;
          }
        }
      }

      :deep(.el-carousel__container) {
        height: 650px;
      }
    }
  }

  .p-card {
    width: 70%;
    margin: 80px auto;

    :deep(.el-progress-circle) {
      width: 50px !important;
      height: 50px !important;
    }

    :deep(.el-progress__text) {
      font-size: 12px !important;
    }

    :deep(.has-gutter) {
      .cell {
        font-size: 12px;
        color: #8fa6bf;
      }
    }
  }

  .m-content {
    padding: 10px;

    .banner-box {
      width: 100%;

      .banner {
        width: 100%;
        height: 150px;
        border-radius: 12px;
      }

      .car-item {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      :deep(.el-carousel__indicators--outside) {
        display: none;
      }
    }

    :deep(.el-carousel__container) {
      height: 200px;
    }

    .task-box {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .box-right {
        display: flex;
        flex-direction: column;
        /* padding: 20px; */

        p {
          font-size: 28px;
          color: rgb(0, 47, 255);
          margin-bottom: 20px;
        }

        .level {
          display: flex;
          align-items: center;
          margin-top: 20px;
          font-size: 16px;
          color: #666;

          img {
            height: 28px;
            margin-right: 10px;
          }
        }

        .line {
          width: 100%;
          height: 1px;
          background: #dcdfe6;
          margin: 24px 0;
        }

        .process {
          display: flex;
          justify-content: space-between;

          .process-left {
            width: 40%;
            border: 1px solid #000;
            border-radius: 6px;
            padding: 10px;
            font-size: 12px;

            .p-title {
              width: 100%;
              color: #666;
              margin-bottom: 5px;
              text-align: center;
            }

            .right {
              width: 100%;
              position: relative;

              span {
                position: absolute;
                top: 2px;
                right: 0;
              }

              :deep(.el-progress-bar) {
                width: 80%;
              }
            }
          }

          .process-right {
            width: 40%;
            display: flex;
            flex-direction: column;
            align-items: center;
            border: 1px solid #000;
            border-radius: 6px;
            padding: 10px;
            font-size: 12px;

            .p-title {
              color: #666;
              margin-bottom: 5px;
            }
          }
        }

        .rate {
          margin: 20px 0;
          font-size: 16px;
          color: #000;
        }

        .income {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 12px;

          .color {
            color: #b63036;
          }

          .n-receive {
            background-color: #999;
            color: #fff;
            padding: 6px 10px;
            border-radius: 3px;
            cursor: pointer;
          }

          .receive {
            background-color: #1f3f7a;
            color: #fff;
            padding: 6px 10px;
            border-radius: 3px;
            cursor: pointer;
          }
        }
      }

      :deep(.el-carousel__container) {
        height: 650px;
      }
    }

    .line {
      width: 100%;
      height: 1px;
      background: #dcdfe6;
      margin: 24px 0 0 0;
    }
  }

  .table-price {
    display: flex;
    align-items: center;

    .price-left {
      display: flex;
      align-items: center;
    }

    .price-right {
      display: flex;
      align-items: center;
    }

    img {
      width: 16px;
      height: 10px;
      margin: 0 3px;
    }

    .up {
      color: #27d9b1;
      font-size: 10px;
    }

    .down {
      color: #b63036;
      font-size: 10px;
    }
  }

  .m-card {
    width: 96%;
    padding-top: 30px;
    padding-bottom: 70px;
    margin: 0 auto;

    .user-name {
      font-size: 12px;
      color: rgb(77, 86, 219);
      font-weight: 600;
    }

    .table-price {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
  }
}
</style>
